import { useMemo } from "react";
import { ESupportTicketQuestionType } from "@devowl-wp/api-real-commerce";
import { __ } from "../utils/i18n.js";
/**
 * Get the question type localized as object.
 */ function useSupportFormQuestionType() {
    return useMemo(()=>{
        const result = {};
        Object.keys(ESupportTicketQuestionType).forEach((key)=>{
            const value = ESupportTicketQuestionType[key];
            let localized = key;
            switch(value){
                case ESupportTicketQuestionType.PreSaleQuestion:
                    localized = __("Pre-sale question");
                    break;
                case ESupportTicketQuestionType.RequestCustomOffer:
                    localized = __("Request custom offer (Enterprise)");
                    break;
                case ESupportTicketQuestionType.SetupOfProduct:
                    // Do not output deprecated question type.
                    return;
                case ESupportTicketQuestionType.ProblemWithProduct:
                    localized = __("I have a problem with my product");
                    break;
                case ESupportTicketQuestionType.ProblemWithLicenseOrAccount:
                    localized = __("I have a problem with my license/account");
                    break;
                case ESupportTicketQuestionType.FeatureRequest:
                    localized = __("Feature request");
                    break;
                default:
                    break;
            }
            result[value] = {
                localized,
                key,
                value
            };
        });
        return result;
    }, []);
}
export { useSupportFormQuestionType };
